export function getLullabies(state) {
  return state.lullaby.byId;
}

export function getLullabiesLibrary(state) {
  return state.lullaby.library;
}

export function getDefaultLullabyId(state) {
  return state.lullaby.defaultLullabyId;
}

export function getDefaultLullaby(state) {
  return state.lullaby.byId[getDefaultLullabyId(state)];
}
